import { Paper, SxProps, Theme } from "@mui/material";
import { useAppSelector } from "../../store/store";

const PaperComponent = ({
  children,
  sx,
}: {
  children: any;
  sx?: SxProps<Theme> | undefined;
}) => {
  const appearance = useAppSelector((state) => state.theme);

  return (
    <Paper
      elevation={0}
      sx={[
        (theme) => ({
          backgroundColor:
            theme.palette.mode === "light"
              ? appearance.actionButtonColor
                ? appearance.actionButtonColor
                : theme.palette.grey[100]
              : appearance.actionButtonColorDark
              ? appearance.actionButtonColorDark
              : theme.palette.grey[900],
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Paper>
  );
};

export default PaperComponent;
